import React, { useContext, useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import Select from "react-select";
import { ResponsiveContainer } from "recharts";
import Chart from "react-apexcharts";
import _ from "lodash";

import { BrandContext } from "../../../contexts/BrandContext";
import { HeaderContext } from "../../../contexts/HeaderContext";

import WidgetSpinner from "../../../components/helper/WidgetSpinner";
import useIsMountedRef from "../../../components/helper/isMountedRef";
// import getRandomRGB,  from "../../../components/helper/isMountedRef";

const chartFont = {
    colors: "gray",
    fontSize: "12px",
    cssClass: "apexcharts-xaxis-label",
};

function CategoryPerformanceLineChart(props) {
    // console.log('CategoryPerformanceLineChart', props);

    const [chartOptions, setChartOptions] = useState({});
    const [series, setSeries] = useState([]);

    const isMountedRef = useIsMountedRef();

    const {
        brand,
        currency,
        chartData,
        chartLabels,
        setMounted,
    } = props;

    const cleanCurrencyFormatter = new Intl.NumberFormat(brand?.currencyLocale ?? "en-US", {
        style: "currency",
        currency: currency,
        maximumFractionDigits: 2,
        minimumFractionDigits: 0,
    });

    const getCleanCurrencyFormatter = (value) => {
        return cleanCurrencyFormatter.format(value);
    };

    useEffect(() => {

        if (
            isMountedRef.current
            && chartData !== undefined
        ) {
            // let labels = chartData.labels;

            // console.log(chartData);
            // let new_series = [];
            // let new_chartOptions = {};

            // for(let i=0; chartData.data.length>i; i++){
            //     new_series.push({
            //         name: chartData.data[i].label,
            //         data: chartData.data[i].data,
            //         type: "line",
            //     })
            // }

            // const widgetColors = ['#84344e','#E3FF00','#313132','#9d555e','#8a8a8b','#b4cb00','#dbff51','#c99b98','#b5b5b5','#a7bd00','#84344e'];

    
            const new_chartOptions = {
                chart: {
                    id: "CategoryPerformanceLineChart",
                    toolbar: {
                        show: false,
                    },
                    zoom: {
                        enabled: false,
                    },
                    dropShadow: {
                        enabled: false,
                    },
                    animations: {
                        enabled: false,
                    },
                    height: "100%",
                    type: "line",
                },
                // plotOptions: {
                //     bar: {
                //         horizontal: false,
                //         columnWidth: '55%',
                //         endingShape: 'rounded'
                //     },
                // },
                legend:{show: false},
                stroke: {
                    show: true,
                    curve: "smooth",
                    lineCap: "butt",
                    // colors: widgetColors,
                },
                grid: {
                    show: true,
                    borderColor: "#eaecec",
                    xaxis: { lines: { show: true } },
                    yaxis: { lines: { show: true } },
                },
                markers: {
                    size: Array(chartData.length).fill(5),
                    strokeWidth: Array(chartData.length).fill(0),
                    strokeOpacity: 1,
                    fillOpacity: 1,
                    hover: { sizeOffset: 1 },
                },
                // colors: widgetColors,
                xaxis: {
                    categories: chartLabels,
                    type: "category",
                    labels: {
                        style: chartFont,
                    },
                    tickPlacement: "between",
                },
                yaxis: {
                    title: {
                        text: "",
                    },
                    min: 0,
                    labels: {
                        formatter: (val) => getCleanCurrencyFormatter(val),
                        style: chartFont,
                    },
                },
            };

            setTimeout(()=>{
                setSeries(chartData);
                setChartOptions(new_chartOptions);
            },100);

        }

    }, [chartData, chartLabels, brand, currency, isMountedRef]);

    return (
        <ResponsiveContainer>
            <Chart options={chartOptions} series={series} type="line"/>
        </ResponsiveContainer>
    );
}

function CategoryPerformanceChart(props) {
    // console.log('CategoryPerformanceChart', props);

    const { brand } = useContext(BrandContext);
    const { currency } = useContext(HeaderContext);

    const {
        headerTitle,
        headerSubtitle,
        widgetData = { data:[], labels:[] },
        widgetOptions = [],
        widgetDataLoading = true,
    } = props;

    const [collectionValue, setCollectionValue] = useState();
    const [chartData, setChartData] = useState();

    useEffect(() => {
        if (widgetOptions.length > 0) {
            setCollectionValue(_.clone(widgetOptions).splice(0, 3));
        }
    }, [widgetOptions]);

    useEffect(() => {
        if (widgetData?.data?.length > 0 && Array.isArray(collectionValue)) {
            let new_series = [];

            const selectedValues = collectionValue.map((option) => option.value);

            for (let i = 0; widgetData.data.length > i; i++) {
                if (!selectedValues.includes(widgetData.data[i].name)) {
                    continue;
                }

                // getColorString(rgb_array, transparency=1)
                new_series.push(widgetData.data[i]);
            }

            setChartData(new_series);
        }
        else {
            setChartData([]);
        }
    }, [widgetData, collectionValue]);

    const updateCollections = (option) =>{
        setCollectionValue(option);
    }

    return (
        <div className="card h-100">
            {headerTitle && 
                <div className="card-header bg-white">
                    <div className="d-flex flex-row align-items-center">
                        <div>
                            <h5 className="mb-0">{headerTitle}</h5>
                            {headerSubtitle && <p className="body-1 text-secondary mb-0 mt-2">{headerSubtitle}</p>}
                        </div>

                    </div>
                </div>
            }

            {
                widgetDataLoading ? 
                <WidgetSpinner />
                :
                <div className="card-body w-100 px-0">
                    <Row>
                        <Col>
                            <Select
                                className="text-dark w-50"
                                placeholder="Select Collections"
                                value={collectionValue}
                                options={widgetOptions}
                                name="CollectionSelect"
                                getOptionLabel={(option) => `${option.label}`}
                                getOptionValue={(option) => option.value}
                                onChange={(option) => {
                                    updateCollections(option)
                                }}
                                isMulti={true}
                                allowSelectAll={false}
                                isSearchable={false}
                                isLoading={false}
                                noOptionsMessage={(inputValue) => "No Collections Available"}
                            />
                        </Col>
                    </Row>
                    <div className="mt-4" style={{height: "34em"}}>
                        <CategoryPerformanceLineChart
                            brand={brand}
                            currency={currency}
                            chartData={chartData}
                            chartLabels={widgetData?.labels ?? []}
                        />
                    </div>
                </div>
            }
        </div>
    );
}

export default CategoryPerformanceChart;
